import { render } from "./Index.vue?vue&type=template&id=5d4a1e37"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5d4a1e37&lang=css"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__